(function ($) {
  function initMap($el) {
    var args = {
      zoom: 13,
      center: mapCenter,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    var map = new google.maps.Map($el[0], args);

    if (Foundation.MediaQuery.atLeast('large')) {
      map.panBy(-50, 0);
    }
    return map;
  }

  function centerMarker(map) {
    var bounds = new google.maps.LatLngBounds();

    $.each(markers, function (i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });

    map.setZoom(14);
    map.panTo(latlng);
    if (Foundation.MediaQuery.atLeast('large')) {
      map.panBy(-50, 0);
    }
  }

  function centerPolygon(map, coords){
    var bounds = new google.maps.LatLngBounds();
    var i;

    for (i = 0; i < coords.length; i++) {
      bounds.extend(coords[i]);
    }

    map.fitBounds(bounds);
    if (Foundation.MediaQuery.atLeast('large')) {
      map.panBy(-50, 0);
    }
  }

  function centerCircles(map, markers){
    if(coords.length > 1){
      var bounds = new google.maps.LatLngBounds();

      $.each(markers, function(index, circle){
        bounds.union(circle.getBounds());
      });

      map.fitBounds(bounds);
    }
    else{
      circle = new google.maps.Circle({
        radius: maxRadius,
        center: coords[0],
      });

      map.fitBounds(markers[0].getBounds());
    }
  }

  function clearMarkers(){
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers = [];
  }

  function addMarkers($markers, map){
    $markers.each(function(){
      latlng = new google.maps.LatLng($(this).attr('data-lat'), $(this).attr('data-lng'));
      marker = new google.maps.Marker({
        position: latlng,
        icon: markerIcon,
        map: map
      });
      markers.push(marker);
    });

    centerMarker(map);
  }

  function addPolygon($markers, map){
    coords = [];

    $markers.each(function(){
      markerCoord = {
        lat: $(this).data('lat'),
        lng: $(this).data('lng')
      };
      coords.push(markerCoord);
    });

    polygon = new google.maps.Polygon({
      paths: coords,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });

    markers.push(polygon);
    polygon.setMap(map);

    centerPolygon(map, coords);
  }

  function addCircles($markers, map){
    coords = [];
    maxRadius = 0;

    $markers.each(function(){
      center = {
        lat: parseFloat($(this).attr('data-lat')),
        lng: parseFloat($(this).attr('data-lng')),
      };

      coords.push(center);
      radius = parseInt($(this).attr('data-rayon'));

      if(radius > maxRadius){
        maxRadius = radius;
      }

      marker = new google.maps.Circle({
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        center: center,
        map: map,
        radius: radius,
      });
      markers.push(marker);
    });

    centerCircles(map, markers);
  }

  function showMarkers($this){
    id = $this.data('id');
    markersGroup = $('.markers-holder[data-id=markers-' + id);

    $markers = markersGroup.find('.marker');

    if($markers.length < 1){
      map.setZoom(14);
      map.panTo(mapCenter);
    }
    else {
      if(markersGroup.data('markers_source') === 'man'){
        if($markers.length === 1){
          addMarkers($markers, map);
        }
        else if($markers.length > 1){
          addPolygon($markers, map);
        }
      }
      else if(markersGroup.data('markers_source') === 'transfos'){
        addCircles($markers, map);
      }
    }
  }

  var map;
  var markers = [];
  var mapCenter = new google.maps.LatLng(49.1191, 6.1727);

  $(document).ready(function () {
    $('.map-clicker').click(function(){
      if(!$(this).hasClass('map-clicker--active')) {

        if($(this).hasClass('map-col-left__item--travaux')){
          iconType = 'travaux';
        }
        else {
          iconType = 'incident';
        }

        markerIcon = {
          url: get_template_directory_uri + '/dist/images/marker-' + iconType + '.svg',
          scaledSize: new google.maps.Size(40, 40), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0) // anchor
        };

        $('.map-clicker--active').each(function(){
          $(this).removeClass('map-clicker--active');
        });
        $('.map-col-left__more--active').each(function(){
          $(this).removeClass('map-col-left__more--active');
        });

        $(this).addClass('map-clicker--active');
        $(this).next().addClass('map-col-left__more--active');

        clearMarkers();
        showMarkers($(this));
      }
    });

    $('.more__close').click(function(){
      $('.map-clicker--active').each(function () {
        $(this).removeClass('map-clicker--active');
      });
      $('.map-col-left__more--active').each(function () {
        $(this).removeClass('map-col-left__more--active');
      });

      clearMarkers();
      map.setZoom(13);
      map.panTo(mapCenter);
    });

    $('.acf-map').each(function () {
      map = initMap($(this));
    });
  });
})(jQuery);
